'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { Stamp } from '@src/components/TopNavV3/Stamp';
import { useTopNav } from '@src/components/TopNavV3/TopNavContext';
import { TopNavMobileFooter } from '@src/components/TopNavV3/TopNavMobile/TopNavMobileFooter';
import { TopNavMobileLinks } from '@src/components/TopNavV3/TopNavMobile/TopNavMobileLinks';
import type { TopNavItem } from '@src/components/TopNavV3/TopNavProps';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
import { cn } from '@src/utils/tailwind';
export const TopNavMobileMenu = () => {
  const $ = _c(12);
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    items,
    setExpanded,
    setExpandedMenu,
    setMobileSubExpanded
  } = useTopNav();
  const renderTitle = _temp;
  let t0;
  if ($[0] !== items || $[1] !== setExpanded || $[2] !== setExpandedMenu || $[3] !== setMobileSubExpanded || $[4] !== trackSelectNavCta) {
    t0 = items?.map((item, index) => {
      if (!item?.hasSubItems) {
        return <LocalizedLink onClick={() => {
          trackSelectNavCta({
            "cta url": item.href
          });
          setExpanded(false);
        }} data-testid={`nav-menu-${index}`} key={item?.title} className="py-3 text-body-lg font-lateral font-medium" href={item.href ?? ""} rel={item.newTab ? "noopener noreferrer" : ""} target={item.newTab ? "_blank" : "_self"}>{renderTitle(item)}</LocalizedLink>;
      }
      return <button data-testid={`nav-menu-${index}`} key={item.title} className={cn("py-3 text-body-lg font-lateral font-medium", "relative flex w-full cursor-pointer items-center gap-2 transition-all")} onClick={() => {
        setExpandedMenu(item);
        setMobileSubExpanded(true);
      }}>{renderTitle(item)}<ChevronRightIcon className="size-5 text-bodi-accent-bright-500" /></button>;
    });
    $[0] = items;
    $[1] = setExpanded;
    $[2] = setExpandedMenu;
    $[3] = setMobileSubExpanded;
    $[4] = trackSelectNavCta;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TopNavMobileLinks />;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t0) {
    t2 = <div className="flex flex-col gap-2 px-4 py-6">{t0}{t1}</div>;
    $[7] = t0;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <TopNavMobileFooter />;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2) {
    t4 = <>{t2}{t3}</>;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
function _temp(menu) {
  return <div className="flex items-center gap-2">{menu.title}<Stamp text={menu.stamp} /></div>;
}